import { z } from 'zod';

export const uuidSchema = z.string().uuid();

export const emailSchema = z.string().email().max(320).toLowerCase().trim();

export const dateStringSchema = z.string().regex(/^\d{4}-\d{2}-\d{2}$/);
